<template>
  <CompAccountNotification v-if="state.seller.id" :seller="state.seller" />
  <CompAccountMsgFuncAgreement v-if="state.seller.id" :seller="state.seller" />
</template>
<script>
import { inject, onMounted, reactive } from 'vue';
import axios from '@/utils/axiosAuth.js';
import CompAccountNotification from '@/views/account/vue/CompAccountNotification.vue';
import CompAccountMsgFuncAgreement from '@/views/account/vue/CompAccountMsgFuncAgreement.vue';

export default {
  components: {
    CompAccountNotification,
    CompAccountMsgFuncAgreement,
  },
  setup() {
    const globalMethods = inject('globalMethods');
    const state = reactive({
      seller: {},
    });
    onMounted(async () => {
      const seller = await axios
        .get('/sellers')
        .then((response) => {
          if (
            response.data &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            return response.data.data[0];
          }
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      await axios
        .get(`/sellers/${seller.id}`)
        .then((response) => {
          if (response.data && response.data.data) {
            state.seller = response.data.data;
          }
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    });
    return {
      state,
    };
  },
};
</script>
